import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimActKc2OtherData, BimActKc2OtherStatusEnum, BimUpdateActKc2OtherCorrectionMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateActKC2OtherCorrectionGql } from '../bimEditActKC2OtherCorrectionQueries';

interface IUseUerCreateActKC2Correction {
    onSuccess?: (data?: BimActKc2OtherData) => void;
    actKc2OtherId: number;
}

const requestId = 'bimUpdateActKC2OtherCorrection';

export const useBimUpdateActKC2OtherCorrection = (props: IUseUerCreateActKC2Correction) => {
    const dispatch = useDispatch();
    const { onSuccess, actKc2OtherId } = props;

    const [bimUpdateActKC2OtherCorrectionReset] = useResetStoreData({
        requestId,
    });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<BimUpdateActKc2OtherCorrectionMutation>) => {
            if (depsVars?.payload?.bimUpdateActKC2OtherCorrection?.data) {
                onSuccess?.(depsVars?.payload?.bimUpdateActKC2OtherCorrection?.data);
            }
            bimUpdateActKC2OtherCorrectionReset(undefined);
        },
        [onSuccess, bimUpdateActKC2OtherCorrectionReset],
    );

    const [, bimUpdateActKC2OtherCorrectionStatus, , bimUpdateActKC2OtherCorrectionRequest] =
        useRequest<BimUpdateActKc2OtherCorrectionMutation>({
            requestId,
            query: bimUpdateActKC2OtherCorrectionGql,
            withEffect: false,
            dependenciesUpdater: onSuccessLocal,
        });

    const bimUpdateActKC2OtherCorrectionMakeRequest = useCallback(
        (status: BimActKc2OtherStatusEnum, correctionDate?: Date) => {
            dispatch(bimUpdateActKC2OtherCorrectionRequest({ input: { id: actKc2OtherId, status, correctionDate } }));
        },
        [actKc2OtherId, bimUpdateActKC2OtherCorrectionRequest, dispatch],
    );

    return { bimUpdateActKC2OtherCorrectionStatus, bimUpdateActKC2OtherCorrectionMakeRequest };
};
